// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2SKGB","loader":"Loading_loader__34D5N"};